import { Mode } from "@mui/icons-material";
import { Box, Button, FormControlLabel, Grid, Switch, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import { MediaServices } from "./MediaServices";

const CreatePathForm = ({onClose}) => {
    const { watch, control, handleSubmit, setValue, formState:{isDirty}} = useForm({
        mode:'onChange',
        defaultValues:{
            folderName:'', 
            isCompressed:false, 
            isCustomer:false, 
            isProvider:false, 
            isCommon:true
        }
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onSubmit = async (data) => {
        console.log("submitted form Data:",data)
        setIsSubmitting(true);
        const isResult = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to create this path?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, create it!',
            allowOutsideClick: false,
        });
        if(isResult.isConfirmed){
            // swal loading
            Swal.fire({
                title: 'Creating...',
                text: 'Please wait while the folder path is being created.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            try {
                const response = await MediaServices.createFolderPath(data);
                if(response.success == '1'){
                    Swal.fire('Created!', 'The folder path has been created.', 'success');
                    onClose();
                } else if(response.success == '0'){
                    Swal.fire('Error!', response.message || 'There was an issue creating the folder path.', 'error');
                } else {
                    Swal.fire('Error!', 'Unexpected response from server.', 'error');
                }
            } catch (error) {
                console.error("Error creating folder path:", error);
                Swal.fire('Error!', 'There was an issue creating the folder path.', 'error');
            }
        }
        setIsSubmitting(false);
    }
    const isCustomer = watch('isCustomer');
    const isProvider = watch('isProvider');
    useEffect(() => {
        if(isCustomer || isProvider){
            setValue('isCommon',false,{shouldDirty:true});
        } else {
            setValue('isCommon',true,{shouldDirty:true});
        }
    }, [isCustomer, isProvider]);
  return (
    <Box>
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',p:'1%',borderBottom:'1px solid #ccc'}}>
            <Typography sx={{fontSize:'0.85rem',fontWeight:600}} > Generate Customer App Url </Typography>
            <Button disabled={isSubmitting} size='small' variant='outlined' color='error' onClick={onClose}>Close</Button>
        </Box>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{p:'2%'}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={10}>
                            <Box sx={{display:'flex',flexDirection:{xs:'column',sm:'row'},alignItems:{xs:'flex-start',sm:'center'},gap:1}}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600,width:{xs:'100%',sm:'20%'}}}>Folder Path <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                                <Controller
                                    name='folderName'
                                    control={control}
                                    rules={{
                                        required: 'Enter path',
                                        pattern: {
                                            value: /^[a-zA-Z/_-]+$/,
                                            message: 'Only alphabets, /, -, _ are allowed'
                                        }
                                    }}
                                    render={({ field , fieldState: { error } }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            size='small'
                                            error={!!error}
                                            helperText={error ? error.message : ''}
                                            InputProps={{
                                                style: { fontSize: '0.75rem' }
                                            }}

                                        />
                                    )}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} >
                            <Controller
                                name="isCompressed"
                                control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        label={<Typography sx={{ fontSize: '0.75rem' }}>Allow Compression</Typography>}                                        
                                        control={<Switch {...field} checked={field.value} size="small" />}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} >
                            <Controller
                                name="isProvider"
                                control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        label={<Typography sx={{ fontSize: '0.75rem' }}>For Provider</Typography>}                                        
                                        control={<Switch {...field} checked={field.value} size="small" />}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} >
                            <Controller
                                name="isCustomer"
                                control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        label={<Typography sx={{ fontSize: '0.75rem' }}>For Customer</Typography>}                                        
                                        control={<Switch {...field} checked={field.value} size="small" />}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2} sx={{textAlign:'center'}}>
                            <Button disabled={ !isDirty  || isSubmitting} type='submit' size='small' variant='contained' color='success' >Create Path</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    </Box>
  )
}

export default CreatePathForm
